import { types } from "../types/types";

export const uiOpenModalDelete = () => ({
    type: types.uiOpenModalDelete
});

export const uiCloseModalDelete = () => ({
    type: types.uiCloseModalDelete
});